import './less/sideBanner.less';

const SideBanner = (selector, stop = false) => {
	let mobileSlider = document.querySelector(selector);
	if (mobileSlider) {
		let slider = $(selector);
		
		slider.owlCarousel({
			loop: false,
			// merge: false,
			rewind: true,
			margin: 0,
			mouseDrag: true,
			navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
			dots: false,
			items: 1,
			nav: true,
		});
		console.log('started');
	}
};

const StopSideBanner = selector => {
	let mobileSlider = document.querySelector(selector);
	if (mobileSlider) {
		let slider = $(selector);
		slider.trigger('destroy.owl.carousel');
		let thumbs = mobileSlider.querySelector('.owl-thumbs');
		if (thumbs) {
			thumbs.remove();
		}
	}
};

let sideBanner = null;

if (window.innerWidth < 768) {
	sideBanner = new SideBanner('#js-mobileSlider');
}

window.addEventListener('resize', function (event) {
	StopSideBanner('#js-mobileSlider');
	if (window.innerWidth < 768) {
		sideBanner = new SideBanner('#js-mobileSlider');
	}
	
});

export {sideBanner};


// WEBPACK FOOTER //
// ./components/sideBanner/sideBanner.js